import React from "react";

const Shimmer = ({ className = "" }) => {
  return (
    <div
      className={`bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300 dark:from-gray-800 dark:via-gray-700 dark:to-gray-800 ${className}`}
      style={{
        backgroundSize: "200% 100%",
        animation: "shimmer 2s ease-in-out infinite",
      }}
    >
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Shimmer;
